// assets
import { TeamOutlined, PartitionOutlined } from '@ant-design/icons';

// icons
const icons = {
    TeamOutlined,
    PartitionOutlined
  };

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const quanlykhachhang = {
  id: 'quanly',
  title: 'Quản Lý',
  type: 'group',
  children: [
    {
      id: 'quan-ly-khach-hang',
      title: 'Quản Lý Khách Hàng',
      type: 'item',
      url: '/quanlykhachhang',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'quan-ly-khu-vuc',
      title: 'Quản Lý Khu Vực',
      type: 'item',
      url: '/quanlykhuvuc',
      icon: icons.PartitionOutlined,
      breadcrumbs: false
    }
  ]
};

export default quanlykhachhang;
